/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputTeamShort
 */
export interface OutputTeamShort {
    /**
     * 
     * @type {number}
     * @memberof OutputTeamShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputTeamShort
     */
    name: string;
}

/**
 * Check if a given object implements the OutputTeamShort interface.
 */
export function instanceOfOutputTeamShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputTeamShortFromJSON(json: any): OutputTeamShort {
    return OutputTeamShortFromJSONTyped(json, false);
}

export function OutputTeamShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTeamShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputTeamShortToJSON(value?: OutputTeamShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

